var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hint)?_c('oc-icon',{staticClass:"hint-question-icon",attrs:{"title":_vm.hint,"type":"question-circle"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }